<nb-card>
  <nb-card-header>
    <span>Kéo thả để sắp xếp thứ tự</span>
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <nb-list
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      class="example-list"
    >
      <nb-list-item *ngFor="let item of list; let i = index" cdkDrag>
        <div class="example-box">
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          <div class="text-heading">
            <nb-icon icon="move-outline"></nb-icon>
            <span> {{ i + 1 }}: {{ item.title }}</span>
          </div>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
